import * as Sentry from '@sentry/react';

export default function sentryInit(environment: string): void {
    if (process.env.NODE_ENV === 'development') {
        console.log('disabling sentry in development');
        return;
    }

    // for compiled mode
    if (window.location.hostname === 'localhost') {
        console.log('disabling sentry on localhost');
        return;
    }

    Sentry.init({
        dsn: 'https://caa20c4d2f3d8b850a9480015526650c@o1021052.ingest.sentry.io/4506300144484352',
        integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
        // Performance Monitoring
        tracesSampleRate: 0.1,
        environment,
        replaysSessionSampleRate: 0.1,
        ignoreErrors: [/invalid JSON from Parse/i], // TODO: Once we migrate to AWS, remove me
    });
}

export function setSentryAccount(accountName: string): void {
    Sentry.setTag('account', accountName);
}

export function setSentryUser(userId: string, userEmail: string): void {
    Sentry.setUser({
        id: userId,
        email: userEmail,
    });
}
